import React, { useEffect, useState } from 'react';
import { EuiFlexGroup, EuiFlexItem, EuiButton, EuiLoadingContent } from '@elastic/eui';
import API from '../../api/axios/API';
import { isEmpty } from 'lodash';
import { useDispatch } from 'react-redux';
import { getLiveOrders } from '../../api/liveOrders/getLiveOrderNewAPI';
import { getLiveOrderDetailsAPI } from '../../api/liveOrders/getLiveOrderDetailsAPI';
import moment from 'moment';

export const WeFastRiderTab = (props) => {
    const { order } = props;
    const [priceEstimate, setPriceEstimate] = useState({});
    const dispatch = useDispatch();

    const tdStyle = {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
    };

    const weFastCostEstimate = async () => {
        let weFastResponse;
        try {
            weFastResponse = await API.post(
                `/restaurants/:restaurantId/wefast/get-order-estimation-time?orderId=${props.orderId}`
            );
        } catch (error) {
            weFastResponse = error;
        }

        if (weFastResponse.success) {
            setPriceEstimate(weFastResponse);
        } else {
            alert(weFastResponse.message);
        }
    };

    useEffect(() => {
        weFastCostEstimate();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const assignWeFastRider = async () => {
        let weFastResponse = '';
        props.setRiderModalOpen();
        try {
            weFastResponse = await API.post(`/restaurants/:restaurantId/wefast/assign-orders `, {
                orderId: props.orderId,
            });
        } catch (error) {
            weFastResponse = error;
        }

        if (weFastResponse.success) {
            // props.stateUpdateData((prevState) => !prevState)
            dispatch(getLiveOrders());
            dispatch(getLiveOrderDetailsAPI());
        } else {
            alert(weFastResponse.message);
        }
    };

    return (
        <EuiFlexGroup direction='column'>
            <EuiFlexItem>
                {!isEmpty(priceEstimate) ? (
                    <EuiFlexItem>
                        <b>WeFast Estimates</b>
                        <table style={{ marginTop: '10px' }}>
                            {/* <tr>
                                <td>Estimated Distance</td>
                                <td>:</td>
                                <td style={tdStyle}>{priceEstimate.dunzo_order_estimation.distance ? `${parseFloat(priceEstimate.dunzo_order_estimation.distance).toFixed(2)} Km` : ''}</td>
                            </tr> */}
                            <tr style={{ borderBottom: '1px solid #D3DAE6' }}>
                                <td style={{ borderRight: '1px solid #D3DAE6' }}>Estimated price</td>
                                {/* <td>:</td> */}
                                <td style={tdStyle}>
                                    {priceEstimate.wefastResponse.order.delivery_fee_amount
                                        ? `${parseFloat(priceEstimate.wefastResponse.order.delivery_fee_amount).toFixed(
                                              2
                                          )}`
                                        : ''}
                                </td>
                            </tr>
                            <tr style={{ borderBottom: '1px solid #D3DAE6' }}>
                                <td style={{ borderRight: '1px solid #D3DAE6' }}>Estimated Pick up time</td>
                                {/* <td>:</td> */}
                                <td style={tdStyle}>
                                    {priceEstimate.wefastResponse.order.points &&
                                    priceEstimate.wefastResponse.order.points.length
                                        ? moment(
                                              priceEstimate.wefastResponse.order.points[0].required_finish_datetime
                                          ).format('DD-MM-YYYY HH:mm:ss')
                                        : ''}
                                </td>
                            </tr>
                            <tr style={{ borderBottom: '1px solid #D3DAE6' }}>
                                <td style={{ borderRight: '1px solid #D3DAE6' }}>Estimated Drop off time</td>
                                {/* <td>:</td> */}
                                <td style={tdStyle}>
                                    {priceEstimate.wefastResponse.order.points &&
                                    priceEstimate.wefastResponse.order.points.length
                                        ? moment(
                                              priceEstimate.wefastResponse.order.points[1].required_finish_datetime
                                          ).format('DD-MM-YYYY HH:mm:ss')
                                        : ''}
                                </td>
                            </tr>
                        </table>
                    </EuiFlexItem>
                ) : (
                    <EuiLoadingContent lines={5} />
                )}
            </EuiFlexItem>
            <EuiFlexItem style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <EuiButton fullWidth={true} fill onClick={assignWeFastRider} disabled={isEmpty(priceEstimate)}>
                    Assign WeFast Rider
                </EuiButton>
            </EuiFlexItem>
        </EuiFlexGroup>
    );
};
